/* eslint-disable */

import moment from "moment";

import { ACTION_TYPE } from '../actions/ActionTypes'
import { ENERGY_MIX_LABEL, DATE_DEFAULT_FORMAT } from "../constants/Miscellaneous";
import { enums } from "../enums";

const INITIAL_STATE = {
  assetsConsuming: [],
  activeUserConsumingAssets: [],
  error: { message: "", isVisible: false },
  loadingConsumingMeterRead: false,
  loading: false,
  lastDashboardLoad: 0,
  loadingYTD: false,
  refreshing: false,
  loadingOnChain: false,
  loadingYTDOnChain: false,
  refreshingOnChain: false,
  order: "asc",
  orderBy: "id",
  selected: [],
  page: 0,
  rowsPerPage: 10,
  mapHeight: 100,
  mapWidth: 100,
  dialogCo2DetailsOpen_Dashboard: false,
  frontEndDataForUser: {
    totalAvoidedCO2GramsForRange: 0,
    totalAvoidedCO2GramsYearToDate: 0,
    totalEnergyMatchedInWhForRange: 0,
    totalEnergyMatchedInWhYearToDate: 0,
    averageDistanceForRangeInMeters: 0,
    averageDistanceYTDInMeters: 0,
    CO2Equivalents:[
      {co2EquivalentName: enums.CO2Equivalents.CO2_PER_TREE_SEEDING_IN_T, co2EquivalentValue: 0},
      {co2EquivalentName: enums.CO2Equivalents.NUCLEAR_WASTE_FOR_1MWH_NUCLEAR_ELECTRICITY_IN_G, co2EquivalentValue: 0},
      {co2EquivalentName: enums.CO2Equivalents.CO2_FOR_1KM_TRAVALLED_IN_G, co2EquivalentValue: 0},
      {co2EquivalentName: enums.CO2Equivalents.WORLD_TOUR_DISTANCE_IN_KM, co2EquivalentValue: 0},
      {co2EquivalentName: enums.CO2Equivalents.CO2_FOR_1KM_DRIVEN_IN_G, co2EquivalentValue: 0},
      {co2EquivalentName: enums.CO2Equivalents.AVERAGE_HOUSEHOLD_ELECTRICITY_CONSUMPTION_IN_KWH, co2EquivalentValue: 0}
    ]
  },
  producingAssetPercentageForRange: [],
  producingAssetPercentageYTD: [],
  producingAssetPercentageLastMatchedDay: [],
  doughnutDataForRange: [],
  doughnutDataYTD: [],
  doughnutDataLastMatchedDay: [],
  lastMatchedDay: "",
  countryNavigationEnabled: false,
  uniqueCountriesArray: [],
  countriesMenuOpen: false,
  globalViewButtonPressed: false,
  countryViewButtonPressed: false
};

const dashboardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_TYPE.DASHBOARD.START:
      return { ...state, loading: true, loadingOnChain: true };

    case "COUNTRIES_MENU_STATE_CHANGED":{
      return { ...state, countriesMenuOpen: action.payload};
    }
      

    case ACTION_TYPE.DASHBOARD.SUCCESS:
      return {
        ...state,
        loading: false,
        loadingOnChain: false,
      };

    case ACTION_TYPE.DASHBOARD.ENABLE_COUNTRY_NAVIGATION:
      return {
        ...state,
        countryNavigationEnabled: true,
        uniqueCountriesArray: action.payload
      };

    case ACTION_TYPE.DASHBOARD.COUNTRY_VIEW_BUTTON_CLICKED:
      return {
        ...state,
        globalViewButtonPressed: false,
        countryViewButtonPressed: true
      };

    case ACTION_TYPE.DASHBOARD.GLOBAL_VIEW_BUTTON_CLICKED:
      return {
        ...state,
        countryViewButtonPressed: false,
        globalViewButtonPressed: true
      };

    case ACTION_TYPE.DASHBOARD.GET_ASSETS_CONSUMING_SUCCESS:
      return { ...state, assetsConsuming: action.payload };
      
    case ACTION_TYPE.DASHBOARD.SET_ACTIVE_USER_CONSUMING_ASSETS:
      return { ...state, activeUserConsumingAssets: action.payload };

    case ACTION_TYPE.DASHBOARD.START_LOADING:  {
      return { ...state, loading: true };
    }

    case ACTION_TYPE.DASHBOARD.SET_LAST_DASHBOARD_LOAD:
      {
        return { ...state, lastDashboardLoad: moment().unix() };
      }

    case ACTION_TYPE.DASHBOARD.RESET_LAST_DASHBOARD_LOAD:
      {
        return { ...state, lastDashboardLoad: 0 };
      }

    case ACTION_TYPE.DASHBOARD.STOP_LOADING: 
      return { ...state,
        loadingConsumingMeterRead: false,
        loading: false,
        loadingYTD: false,
        refreshing: false,
        loadingOnChain: false,
        loadingYTDOnChain: false,
        refreshingOnChain: false
      };

    case ACTION_TYPE.DASHBOARD.GET_ASSETS_CONSUMING_FAIL:
      return { ...state };
    
    case ACTION_TYPE.DASHBOARD.GET_ASSETS_CONSUMING_FAIL.SORT_ASSETS_CONSUMING:
      const assetsConsuming = action.payload.assetsConsuming;
      const order = action.payload.order;
      const orderBy = action.payload.orderBy;
      return { ...state, assetsConsuming, order, orderBy };

    case ACTION_TYPE.DASHBOARD.CHANGE_PAGE:
      const page = action.payload.page;
      return { ...state, page };

    case ACTION_TYPE.DASHBOARD.CHANGE_ROWS_PER_PAGE:
      const rowsPerPage = action.payload.rowsPerPage;
      return { ...state, rowsPerPage };

    case ACTION_TYPE.DASHBOARD.TOGGLE_CO2_DETAILS:
      const dialogCo2DetailsOpen_Dashboard = !state.dialogCo2DetailsOpen_Dashboard; 
      return { ...state, dialogCo2DetailsOpen_Dashboard };

    case ACTION_TYPE.DASHBOARD.LOGOUT_SUCCESS:
      return INITIAL_STATE;

    case ACTION_TYPE.DASHBOARD.GET_FRONT_END_DATA_FOR_USER:
      {
        return { ...state, frontEndDataForUser: action.payload };
      }
      

    case ACTION_TYPE.DASHBOARD.GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS: {
      let producingAssetPercentageForRange = action.payload;

      let doughnutDataForRange = producingAssetPercentageForRange.percentageOfMatchedEnergyArray.map(e => { return {
        asset: e.producingAsset,
        percentage: e.percentageOfMatchedEnergy * 100
      }});

      doughnutDataForRange.push({
        asset: { displayedName:  ENERGY_MIX_LABEL},
        percentage: producingAssetPercentageForRange.percentageOfEnergyMix * 100
      })

      return { ...state, 
        producingAssetPercentageForRange,
        doughnutDataForRange
      };
    }

    case ACTION_TYPE.DASHBOARD.GET_PRODUCING_ASSET_PERCENTAGE_YTD_SUCCESS: {
      let producingAssetPercentageYTD = action.payload;

      let doughnutDataYTD = producingAssetPercentageYTD.percentageOfMatchedEnergyArray.map(e => { return {
        asset: e.producingAsset,
        percentage: e.percentageOfMatchedEnergy * 100
      }});

      doughnutDataYTD.push({
        asset: { displayedName:  ENERGY_MIX_LABEL},
        percentage: producingAssetPercentageYTD.percentageOfEnergyMix * 100
      })

      return { ...state, 
        producingAssetPercentageYTD,
        doughnutDataYTD
      };
    }

    case ACTION_TYPE.DASHBOARD.SET_MATCHING_FREQUENCY: {
        return { ...state, matchingFrequency: action.payload };
    }

    case ACTION_TYPE.DASHBOARD.GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS: {
      let producingAssetPercentageLastMatchedDay = action.payload;
      let lastMatchedDay = producingAssetPercentageLastMatchedDay.periodEnd;

      let doughnutDataLastMatchedDay = producingAssetPercentageLastMatchedDay.percentageOfMatchedEnergyArray.map(e => { return {
        asset: e.producingAsset,
        percentage: e.percentageOfMatchedEnergy * 100
      }});

      doughnutDataLastMatchedDay.push({
        asset: { displayedName:  ENERGY_MIX_LABEL},
        percentage: producingAssetPercentageLastMatchedDay.percentageOfEnergyMix * 100
      })

      return { ...state, 
        producingAssetPercentageLastMatchedDay,
        doughnutDataLastMatchedDay,
        lastMatchedDay
      };
    }

    default:
      return state;
  }
};

export default dashboardReducer;



// WEBPACK FOOTER //
// ./src/reducers/dashboardReducer.js